import { fr as primeLocaleFr } from "primelocale/js/fr.js";
import { Locale } from "primelocale/js/locale.js";
import { nl as primeLocaleNl } from "primelocale/js/nl.js";
import { PrimeNG } from "primeng/config";

import { SupportedLocale } from "@intocare/datatypes/lib/i18n";

const PRIME_NG_LOCALE_DATA = {
	"nl-BE": {
		...primeLocaleNl,
		// TODO: Verify our old translations, are they still valid? E.g., nl vs nl-BE?
		//		These where different from what we get from the PrimeNG locale package.
		//    Maybe we can get them from the Intl API or another well established source?
		emptyMessage: "Geen opties voor deze filter",
		emptySearchMessage: "Geen resultaat voor deze filter",
		emptyFilterMessage: "Geen resultaat voor deze filter",
		dateFormat: "dd/mm/yy",
		monthNames: [
			"Januari",
			"Februari",
			"Maart",
			"April",
			"Mei",
			"Juni",
			"Juli",
			"Augustus",
			"September",
			"Oktober",
			"November",
			"December",
		],
		monthNamesShort: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
		dayNames: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
		dayNamesMin: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
		dayNamesShort: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
	},
	"fr-BE": {
		...primeLocaleFr,
		// TODO: Verify our old translations, are they still valid? E.g., fr vs fr-BE?
		//		These where different from what we get from the PrimeNG locale package.
		//    Maybe we can get them from the Intl API or another well established source?
		emptyMessage: "Aucune option pour ce filtre",
		emptySearchMessage: "Aucun résultat pour ce filtre",
		emptyFilterMessage: "Aucun résultat pour ce filtre",
		dateFormat: "dd/mm/yy",
		monthNames: [
			"Janvier",
			"Février",
			"Mars",
			"Avril",
			"Mai",
			"Juin",
			"Juillet",
			"Août",
			"Septembre",
			"Octobre",
			"Novembre",
			"Décembre",
		],
		monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"],
		dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
		dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
		dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
	},
} as const satisfies Record<SupportedLocale, Locale>;

export function providePrimengLocale(primeNG: PrimeNG, locale: SupportedLocale) {
	primeNG.setTranslation(PRIME_NG_LOCALE_DATA[locale]);
}
